import { SUCCESS_RESPONSE } from "../codeResponses/codes";
import { FetchError } from "../errors/FetchError";
import handleErrorMessage from "../errors/handleErrorMessage";
import { readJsonResponse } from "../errors/tooManyRequests";
import { APP_SETTINGS } from "../utils";
import { getToken } from "./authorization";
import { fetchWithAuthorization, fetchWithAuthorizationToken } from "./fetch";

export const signUp = async (object) => {
  object["isCompany"] = Boolean(object["isCompany"]);

  if (object["isCompany"]) {
    const name = object["firstname"].split(" ");
    object["firstname"] = name[0];
    object["lastname"] = name[1];
  }

  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${APP_SETTINGS.API_URL}/auth/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
        },
        body: JSON.stringify(object),
      });
      const data = await readJsonResponse(response);
      if (data?.code === SUCCESS_RESPONSE.OK) {
        resolve(data);
      } else {
        reject(data);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const signIn = async (credentials) => {
  const response = await fetch(`${APP_SETTINGS.API_URL}/auth/signin`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json, text/plain, /",
    },
    body: JSON.stringify(credentials),
  });
  const data = await readJsonResponse(response);

  if (!response.ok) {
    throw data
  }

  return data;
};

export const getMyProfile = async (token) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${APP_SETTINGS.API_URL}/user/me`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
          Authorization: `Bearer ${token}`,
        },
      });
      const profile = await readJsonResponse(response);
      resolve(profile);
    } catch (error) {
      reject(error);
    }
  });
};

export const checkUserToken = async (token) => {
  try {
    const { data } = await fetchWithAuthorizationToken(
      `/auth/check/token`,
      token
    );
    return data;
  } catch (error) {
    handleErrorMessage(error);
  }
};

export const signOut = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${APP_SETTINGS.API_URL}/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json, text/plain, */*",
          Authorization: `Bearer ${getToken()}`,
        },
      });
      resolve(await readJsonResponse(response));
    } catch (error) {
      reject(error);
    }
  });
};

export const LoginHistory = async (token) => {
  const response = await fetch(
    `${APP_SETTINGS.API_URL}/login-histories/users/me?page=1&limit=5`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((result) => {
      return readJsonResponse(result);
    })
    .then((json) => {
      return json;
    })
    .catch((error) => {
      return null;
    });
  return response;
};

export const LoginHistoryStore = async (token) => {
  const response = await fetch(
    `${APP_SETTINGS.API_URL}/login-histories/stores/me?page=1&limit=5`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json, text/plain, */*",
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((result) => {
      return readJsonResponse(result);
    })
    .then((json) => {
      return json;
    })
    .catch((error) => {
      return null;
    });
  return response;
};

export const confirmMailRequest = async (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${APP_SETTINGS.API_URL}/auth/send/confirmation/email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
          body: JSON.stringify({ email }),
        }
      );
      const data = await readJsonResponse(response);
      if (data?.code === SUCCESS_RESPONSE.OK) {
        resolve(data);
      } else {
        reject(data);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const confirmMail = async (queries) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${APP_SETTINGS.API_URL}/auth/confirm/email?email=${queries.email}&token=${queries.token}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
        }
      );
      const data = await readJsonResponse(response);
      if (data?.code === SUCCESS_RESPONSE.OK) {
        resolve(data);
      } else {
        reject(data);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const forgotPasswordRequest = async (email) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${APP_SETTINGS.API_URL}/auth/forgot/password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
          body: JSON.stringify({ email }),
        }
      );
      const data = await readJsonResponse(response);
      if (data?.code === SUCCESS_RESPONSE.OK) {
        resolve(data);
      } else {
        //we've got an error here
        reject(data);
      }
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const resetPasswordRequest = async (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(
        `${APP_SETTINGS.API_URL}/auth/forgot/password-reset`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json, text/plain, */*",
          },
          body: JSON.stringify(body),
        }
      );
      const data = await readJsonResponse(response);
      if (data?.code === SUCCESS_RESPONSE.OK) {
        resolve(data);
      } else {
        reject(data);
      }
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export const changeUserPassword = async (obj) => {
  try {
    const data = await fetchWithAuthorization(
      "/auth/change/password",
      obj,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to change Password");
  }
};
